import {
	FaBootstrap,
	FaCss3Alt,
	FaGithub,
	FaHtml5,
	FaNpm,
	FaReact,
	FaSass,
	FaYarn,
	FaFigma,
} from "react-icons/fa";
import { SiMongodb, SiMongoose } from "react-icons/si"
import { DiJavascript1 } from "react-icons/di";
import { SiDotenv } from "react-icons/si";
import { FaNode } from "react-icons/fa";
import { SiExpress } from "react-icons/si";
import { SiJsonwebtokens } from "react-icons/si";
import { SiNodemon } from "react-icons/si";
import { SiReactrouter } from "react-icons/si";
import { SiMysql } from "react-icons/si";
import { VscJson } from "react-icons/vsc";
import { FaPhp } from "react-icons/fa";

import {
	SiAdobephotoshop,
	SiTailwindcss,
	SiNextdotjs,
	SiTypescript,
	SiFirebase,
	SiStyledcomponents,
	SiFramer,
	SiMaterialui,
	SiRedux
} from "react-icons/si";

export const SkillsData = [
	{
		name: "HTML",
		icon: <FaHtml5 />,
	},
	{
		name: "CSS",
		icon: <FaCss3Alt />,
	},
	{
		name: "Sass",
		icon: <FaSass />,
	},
	{
		name: "Javascript",
		icon: <DiJavascript1 />,
	},
	{
		name: "TypeScript",
		icon: <SiTypescript />,
	},
	{
		name: "React Js",
		icon: <FaReact />,
	},
	// {
	// 	name: "Next Js",
	// 	icon: <SiNextdotjs />,
	// },
	// {
	// 	name: "Redux",
	// 	icon: <SiRedux />,
	// },
	{
		name: "Firebase",
		icon: <SiFirebase />,
	},
	{
		name: "JSON",
		icon: <VscJson />,
	},
	{
		name: "Bootstrap",
		icon: <FaBootstrap />,
	},
	{
		name: "Tailwind",
		icon: <SiTailwindcss />,
	},
	// {
	// 	name: "Styled Components",
	// 	icon: <SiStyledcomponents />,
	// },
	{
		name: "Framer Motion",
		icon: <SiFramer />,
	},
	{
		name: "Photoshop",
		icon: <SiAdobephotoshop />,
	},
	{
		name: "Git",
		icon: <FaGithub />,
	},
	{
		name: "Npm",
		icon: <FaNpm />,
	},
	// {
	// 	name: "Yarn",
	// 	icon: <FaYarn />,
	// },
	// {
	// 	name: "Figma",
	// 	icon: <FaFigma />,
	// },
	{
		name: "Mongodb",
		icon: <SiMongodb />,
	},
	{
		name: "Mongoose",
		icon: <SiMongoose />,
	},
	{
		name: "Dotenv",
		icon: <SiDotenv />,
	},
	{
		name: "React Router",
		icon: <SiReactrouter />,
	},
	{
		name: "Node",
		icon: <FaNode />,
	},
	{
		name: "Nodemon",
		icon: <SiNodemon />,
	},
	{
		name: "Express",
		icon: <SiExpress />,
	},
	{
		name: "Json Web Token",
		icon: <SiJsonwebtokens />,
	},
	{
		name: "MySQL",
		icon: <SiMysql />,
	},
	{
		name: "PHP",
		icon: <FaPhp />,
	}
];
